// extracted by mini-css-extract-plugin
export var activeIcon = "Menu-module--activeIcon--e6374";
export var activeLink = "Menu-module--activeLink--3a92d";
export var blink = "Menu-module--blink--c4fdb";
export var dropdownLink = "Menu-module--dropdownLink--80827";
export var dropdownParent = "Menu-module--dropdownParent--1171b";
export var featuredLink = "Menu-module--featuredLink--e0582";
export var featuredSection = "Menu-module--featuredSection--a2bb8";
export var featuredTitle = "Menu-module--featuredTitle--48669";
export var gradient = "Menu-module--gradient--a8508";
export var hoverMenu = "Menu-module--hoverMenu--9174b";
export var link = "Menu-module--link--0602b";
export var linkSection = "Menu-module--linkSection--140aa";
export var linkSectionTitle = "Menu-module--linkSectionTitle--9c43b";
export var menu = "Menu-module--menu--7c82d";
export var menuDropdown = "Menu-module--menuDropdown--c14e6";
export var spin = "Menu-module--spin--e242c";
export var submenu = "Menu-module--submenu--7492a";
export var tagFeatured = "Menu-module--tagFeatured--027bf";